module.exports = __webpack_public_path__ + "assets/img/icon04.b7b9cf35.png";